import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './pages/Layout';
import Dashboard from './pages/Dashboard';
// import { Reports, Settings } from './components/Reports';
import 'leaflet/dist/leaflet.css';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/ws_monitoring" element={<Layout />}>
          <Route index element={<Dashboard />} />
          {/* <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<Settings />} /> */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;